$(document).ready(function(){
  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);
  
  $(".business_card_type_filter_block .exp-switch-input.exp-switch-input-main").click(function(){
      var get_filter_option_value = $(this).val();
      //alert("Filter selection = "+get_filter_option_value);
      if(get_filter_option_value == "Standard"){
       // $(".standard_business_card_option").show();
        //$(".team_business_card_option").hide();
        $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected","Standard");

          $(".standard_business_card_option input").each(function(){
             $(this).prop("disabled", false);
          });  
          $(".team_business_card_option input").each(function(){
             $(this).prop("disabled", true);            
          });

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){                   
                  $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
              }else{
                  $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
              }        
        
      }else{
        //$(".standard_business_card_option").hide();
        //$(".team_business_card_option").show();
        $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected","Team");

          $(".standard_business_card_option input").each(function(){
             $(this).prop("disabled", true);
          });          
          $(".team_business_card_option input").each(function(){
             $(this).prop("disabled", false);            
          });  

            if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){ 
                $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
            }else{
                $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
            }            
        
      }
    
    
  });


  $(".business_card_type_standard_filter_block .exp-switch-input").click(function(){
      var get_filter_option_value = $(this).val();
      //alert("Filter selection = "+get_filter_option_value);
      if(get_filter_option_value == "Team"){
           $("#team").trigger("click");  
           $("#standard_filter_block_standard").prop("checked", true);
           $("#standard_filter_block_team").prop("checked", false);
        
           $("#team_filter_block_team").prop("checked", true);
           $("#team_filter_block_standard").prop("checked", false);
      }       
  });

  $(".business_card_type_team_filter_block .exp-switch-input").click(function(){
      var get_filter_option_value = $(this).val();
      //alert("Filter selection = "+get_filter_option_value);
      if(get_filter_option_value == "Standard"){
            $("#standard").trigger("click");    
            $("#team_filter_block_standard").prop("checked", true);
            $("#team_filter_block_team").prop("checked", false); 

            $("#standard_filter_block_standard").prop("checked", true);      
            $("#standard_filter_block_team").prop("checked", false);
      }        
  });  
  

  $(".customize_your_business_cards_type_selection_btn").click(function(){

      if($("input[name='properties[Choose Yard Sign Design]']:checked").is(':checked')){ 
       // alert("Standard both selected");
         $('product-info.main-product-business-card-section').attr("data-business-card-step",2);
         $('.product-business-card-hero-banner-section').attr("data-business-card-step",2);
                  var get_front_card_type = $("input[name='properties[Choose Yard Sign Design]']:checked").val();                  
                  if(get_front_card_type == "Picture Yourself"){
                      $(".main_profile_picture").show();
                      $(".main_profile_picture #file").prop("disabled", false);                      
                  }else{
                      $(".main_profile_picture").hide();
                      $(".main_profile_picture #file").prop("disabled", true);                    
                  } 
                  
                  if(get_front_card_type == "Provide My Own"){
                      $(".line-item-property__field_provide_my_own_file").show();
                      $(".line-item-property__field_provide_my_own_file #line-item-provide_my_own_file").prop("disabled", false);                      
                  }else{
                      $(".line-item-property__field_provide_my_own_file").hide();
                      $(".line-item-property__field_provide_my_own_file #line-item-provide_my_own_file").prop("disabled", true);                    
                  }                   
        
      }


      

     var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");
      //alert("Please select card type "+get_filter_option_type);
      
      if(get_filter_option_type == "Standard"){
              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked')){                 
                  //alert('One of the radio buttons is checked!');
                  var get_front_image = $("input[name='properties[Standard - Choose front]']:checked").closest(".standard-choose_front_option_item").find('.option_image_block').html();
                  $(".product_business-card_media-wrapper .option_image_block_front").html(get_front_image);
                  var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();
                  //alert(get_front_card_type);
                  if(get_front_card_type == "No Picture"){
                      $(".main_profile_picture").hide();
                      $(".main_profile_picture #file").prop("disabled", true);                    
                  }else{
                      $(".main_profile_picture").show();
                      $(".main_profile_picture #file").prop("disabled", false);
                  }
                
                //main_profile_picture
              
              }else {
                 //alert('Nothing is checked!'); 
              }     
        
              if($("input[name='properties[Standard - Choose back]']:checked").is(':checked')){                 
                  //alert('One of the radio buttons is checked!');
                  var get_back_image = $("input[name='properties[Standard - Choose back]']:checked").closest(".standard-choose_back_option_item").find('.option_image_block').html();
                  $(".product_business-card_media-wrapper .option_image_block_back").html(get_back_image);                  

                  var get_back_card_type = $("input[name='properties[Standard - Choose back]']:checked").val();
                  //alert(get_front_card_type);
                  if(get_back_card_type == "QR - Yellow" || get_back_card_type == "QR - Half Yellow" || get_back_card_type == "QR - Blue" || get_back_card_type == "QR - Half Blue" || get_back_card_type == "QR - Square Yellow" || get_back_card_type == "QR - Square Blue" || get_back_card_type == "QR - Angle Yellow"){
                      $(".line-item-property_QR_block").show();                      
                      $(".line-item-property_QR_block input").each(function(){
                          $(this).prop("disabled", false);  
                      });                    
                  }else{
                      $(".line-item-property_QR_block").hide();
                      $(".line-item-property_QR_block input").each(function(){
                          $(this).prop("disabled", true);  
                      });                                                      
                  }

                
              }else {
                 //alert('Nothing is checked!'); 
              }  


      }else{
        
              if($("input[name='properties[Team - Choose front]']:checked").is(':checked')){                 
                //alert('One of the radio buttons is checked!');
                  var get_front_image = $("input[name='properties[Team - Choose front]']:checked").closest(".team-choose_front_option_item").find('.option_image_block').html();
                  $(".product_business-card_media-wrapper .option_image_block_front").html(get_front_image);                

                  var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();
                  //alert(get_front_card_type);
                  if(get_front_card_type == "No Picture"){
                      $(".main_profile_picture").hide();
                      $(".main_profile_picture #file").prop("disabled", true);                    
                  }else{
                      $(".main_profile_picture").show();
                      $(".main_profile_picture #file").prop("disabled", false);
                  }
                
              }else {
                 //alert('Nothing is checked!'); 
              }     
        
              if($("input[name='properties[Team - Choose back]']:checked").is(':checked')){                 
                //alert('One of the radio buttons is checked!');
                  var get_back_image = $("input[name='properties[Team - Choose back]']:checked").closest(".team-choose_front_option_item").find('.option_image_block').html();
                  $(".product_business-card_media-wrapper .option_image_block_back").html(get_back_image); 

                 var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();
                  //alert(get_front_card_type);
                
                  if(get_back_card_type == "2 Team Circle" || get_back_card_type == "2 Team Square"){
                      $(".team_member_1").show();                      
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", false);  
                      }); 
                      $(".team_member_2").show();                      
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", false);  
                      });  

                      $(".team_member_3").hide();                      
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", true);  
                      });  
                      $(".team_member_4").hide();                      
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", true);  
                      }); 
                    
                  }else if(get_back_card_type == "3 Team Circle" || get_back_card_type == "3 Team Square"){
                      $(".team_member_1").show();                      
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", false);  
                      }); 
                      $(".team_member_2").show();                      
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", false);  
                      });  
                      $(".team_member_3").show();                      
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", false);  
                      });   

                      $(".team_member_4").hide();                      
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", true);  
                      }); 
                    
                  }else if(get_back_card_type == "4 Team Circle" || get_back_card_type == "4 Team Square"){
                      $(".team_member_1").show();                      
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", false);  
                      }); 
                      $(".team_member_2").show();                      
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", false);  
                      });  
                      $(".team_member_3").show();                      
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", false);  
                      });  
                      $(".team_member_4").show();                      
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", false);  
                      });                      
                  }else{
                      $(".team_member_1").hide();                      
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", true);  
                      }); 
                      $(".team_member_2").hide();                      
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", true);  
                      });  
                      $(".team_member_3").hide();                      
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", true);  
                      });  
                      $(".team_member_4").hide();                      
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", true);  
                      });                                                     
                  }
                
              }else {
                 //alert('Nothing is checked!'); 

                             
                
              }      

              if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){ 
                //alert("Team both selected");
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",2);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",2);                
              }        
      }
    
  
  });  

  $(".pro_back_btn").click(function(){

              if($("input[name='properties[Choose Yard Sign Design]']:checked").is(':checked')){ 
               //   alert("Standard both selected");
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",1);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);                
              }
    
     var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");
      //alert("Please select card type "+get_filter_option_type);
      
      if(get_filter_option_type == "Standard"){
              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked')){                 
                //alert('One of the radio buttons is checked!');
              }else {
                // alert('Nothing is checked!'); 
              }     
        
              if($("input[name='properties[Standard - Choose back]']:checked").is(':checked')){                 
               // alert('One of the radio buttons is checked!');
              }else {
                 //alert('Nothing is checked!'); 
              }  

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){ 
               //   alert("Standard both selected");
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",1);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);                
              }
      }else{
        
              if($("input[name='properties[Team - Choose front]']:checked").is(':checked')){                 
               // alert('One of the radio buttons is checked!');
              }else {
                 //alert('Nothing is checked!'); 
              }     
        
              if($("input[name='properties[Team - Choose back]']:checked").is(':checked')){                 
               // alert('One of the radio buttons is checked!');
              }else {
                // alert('Nothing is checked!'); 
              }      

              if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){ 
                //  alert("Team both selected");
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",1);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);                
              }        
      }
    
  
  });   

  $(".customize_your_business_cards_type_selection_section .line-item-property__field input").change(function(){
    //alert("ff");properties[Choose Sign Riders Design]
              if($("input[name='properties[Choose Yard Sign Design]']:checked").is(':checked')){                   
                  $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
                  var get_selected_option_image = $(this).closest(".standard-choose_front_option_item").find(".option_image_block img").attr("src");
                  $(".product_business-card_media-slider-wrapper .option_image_block_front").find("img").attr("src",get_selected_option_image);

                  var get_front_card_type = $("input[name='properties[Choose Yard Sign Design]']:checked").val();                  
                  if(get_front_card_type == "Picture Yourself"){
                      $(".main_profile_picture").show();
                      $(".main_profile_picture #file").prop("disabled", false);                      
                  }else{
                      $(".main_profile_picture").hide();
                      $(".main_profile_picture #file").prop("disabled", true);                    
                  }                

                
              }else{
                  $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
              }    
    /*
     var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected"); 
      
      if(get_filter_option_type == "Standard"){

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){                   
                  $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
              }else{
                  $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
              }
      }else{    

            if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){ 
                $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
            }else{
                $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
            }        
      }
    */
  
  });   


  
  $(".product-form_business_card_submit").click(function(){     
      
          var dInput_first_name = $("#first-name").val();  
          var dInput_last_name = $("#last-name").val(); 
          var dInput_nmls_id = $("#nmls-id").val(); 
          var dInput_phone_number = $("#phone_number").val(); 
          var dInput_email = $("#email").val(); 
          var dInput_qrUrl = $("#qrUrl").val(); 
          if(dInput_first_name.length>= 1){
              $("#first-name").removeClass("error_input");
          }else{
              $("#first-name").addClass("error_input");
          }
          if(dInput_last_name.length>= 1){
              $("#last-name").removeClass("error_input");
          }else{
              $("#last-name").addClass("error_input");
          }   

          if(dInput_nmls_id.length>= 1){
              $("#nmls-id").removeClass("error_input");
          }else{
              $("#nmls-id").addClass("error_input");
          }   
          if(dInput_phone_number.length>= 1){
              $("#phone_number").removeClass("error_input");
          }else{
              $("#phone_number").addClass("error_input");
          }  

          if(dInput_email.length>= 1){
              $("#email").removeClass("error_input");
          }else{
              $("#email").addClass("error_input");
          }   
          if(dInput_qrUrl.length>= 1){
              $("#qrUrl").removeClass("error_input");
          }else{
              $("#qrUrl").addClass("error_input");
          }         

          var get_front_card_type = $("input[name='properties[Choose Yard Sign Design]']:checked").val();                  
          if(get_front_card_type == "Picture Yourself"){
              if ($('#file').get(0).files.length === 0) {
                  $("#file").addClass("error_input");
              }else{
                  $("#file").removeClass("error_input");
              } 

              if(dInput_first_name.length>= 1 && dInput_last_name.length>= 1 && dInput_nmls_id.length>= 1 && dInput_phone_number.length>= 1 && dInput_email.length>= 1 && dInput_qrUrl.length>= 1 && $('#file').get(0).files.length >= 1){
                  //$(".product-form__buttons_inner").removeClass("buy_btn_block");
                  $(".product-form form .product-form__buttons .product-form__submit").trigger("click");
              }else{
        
                  $('html, body').animate({
                      scrollTop: $("#product_page_customize_block_section").offset().top
                  }, 2000); 
                
              } 
            
          }else{
            
              if(dInput_first_name.length>= 1 && dInput_last_name.length>= 1 && dInput_nmls_id.length>= 1 && dInput_phone_number.length>= 1 && dInput_email.length>= 1 && dInput_qrUrl.length>= 1){
                  //$(".product-form__buttons_inner").removeClass("buy_btn_block");
                  $(".product-form form .product-form__buttons .product-form__submit").trigger("click");
              }else{
        
                  $('html, body').animate({
                      scrollTop: $("#product_page_customize_block_section").offset().top
                  }, 2000); 
                
              }                          
          }  
    

      //$(".product-form form .product-form__buttons .product-form__submit").trigger("click");
  }); 

  function applyQrCode() {
    $('#qr .bg canvas')[0].toBlob((blob) => {
      const file = new File([blob], "officer-url.png", {type: blob.type} );
      console.log(file);
      const transfer = new DataTransfer();
      transfer.items.add(file);
      $('#qr_code_file_upload')[0].files = transfer.files;
    });
  }
  
  function generateQrCode() {
    const qrUrl = $('#qrUrl').val();
    console.log(qrUrl);
    if (URL.canParse(qrUrl)) {
      $('#qr .bg').empty().qrcode({
          width: $('#qrWidth').val(),
          height: $('#qrHeight').val(),
          color: $('#qrColor').val(),
          bgColor: $('#qrBgColor').val(),
          text: qrUrl
      });
      $('#qr .bg').css({ background: $('#qrBgColor').val()});
      applyQrCode();
    } else {
      $('#qr .bg').empty();
      $('#qr_code_file_upload').val('');
    }
  }

  $('#generate').click(generateQrCode);


  function download(canvas, filename) {
        var canvas = document.getElementById('canvas');
        var lnk = document.createElement('a'), e;

        lnk.download = filename;

        lnk.href = canvas.toDataURL("image/png;base64");

        if (document.createEvent) {
            e = document.createEvent("MouseEvents");
            e.initMouseEvent("click", true, true, window,
                0, 0, 0, 0, 0, false, false, false,
                false, 0, null);

            lnk.dispatchEvent(e);
        } else if (lnk.fireEvent) {
            lnk.fireEvent("onclick");
        }
    }


    $('.qr-png-download').on('click', function (){
        $('canvas').attr('id', 'canvas');
         var canvas = document.getElementById('canvas');
      download(canvas, 'qrcode.png')
      
    });

    $('#is-some-information-incorrect-or-missing').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){                 
          $(this).closest(".customize_additional_information_section").addClass("active_message_box");
          $(this).closest(".customize_additional_information_section").find("textarea").prop("disabled", false); 
          $(this).closest(".customize_additional_information_section").find(".line-item-property_some_information_field").slideDown();          
        }else {
          $(this).closest(".customize_additional_information_section").removeClass("active_message_box");
          $(this).closest(".customize_additional_information_section").find("textarea").prop("disabled", true); 
          $(this).closest(".customize_additional_information_section").find(".line-item-property_some_information_field").slideUp();          
        }               
    });
  
    $('.line-item_include_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){                 
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $(this).closest(".line-item_switch").find(".line-item_switch_label").html("Include");
          $(this).closest(".line-item-property_include_switch_field").find("input[type='text']").prop("disabled", false); 
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $(this).closest(".line-item_switch").find(".line-item_switch_label").html("Don’t include");       
          $(this).closest(".line-item-property_include_switch_field").find("input[type='text']").prop("disabled", true); 
        }        
       // alert(get_line_item_switch_value);
    });

    $('.line-item_address_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){                 
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#street").removeClass("input_lock_field");
          $("#street").closest(".line-item-property__field").addClass("disable_input_lock_field");
          
          $("#city").removeClass("input_lock_field");
          $("#city").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          
          $("#state").removeClass("input_lock_field");
          $("#state").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          
          $("#zip-code").removeClass("input_lock_field");                    
          $("#zip-code").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#street").addClass("input_lock_field");
          $("#street").closest(".line-item-property__field").removeClass("disable_input_lock_field");
          $("#street").val($("#street").attr("data-street"));
          
          $("#city").addClass("input_lock_field");
          $("#city").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#city").val($("#city").attr("data-city"));
          
          $("#state").addClass("input_lock_field");
          $("#state").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#state").val($("#state").attr("data-state"));
          
          $("#zip-code").addClass("input_lock_field");
          $("#zip-code").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#zip-code").val($("#zip-code").attr("data-zip-code"));
        }               
    });

    $('.line-item_business_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){                 
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#business").removeClass("input_lock_field");     
          $("#business").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          $("#business").prop("disabled", false); 
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#business").addClass("input_lock_field");    
          $("#business").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#business").val($("#business").attr("data-business"));          
        }               
    });  

    $('.line-item_mobile_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){                 
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#main_mobile").removeClass("input_lock_field");     
          $("#main_mobile").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          $("#main_mobile").prop("disabled", false); 
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#main_mobile").addClass("input_lock_field");    
          $("#main_mobile").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#main_mobile").val($("#main_mobile").attr("data-main-mobile"));          
        }               
    });  

    $('.line-item_fax_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){                 
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#fax").removeClass("input_lock_field");     
          $("#fax").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          $("#fax").prop("disabled", false); 
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#fax").addClass("input_lock_field");    
          $("#fax").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#fax").val($("#fax").attr("data-fax"));          
        }               
    });    

      $("body").on('keyup change', '#qrUrl', function(e) {
        
          generateQrCode();        
      });   

// Select all links with hashes
$('.back_to_top_btn')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  $('.customize_search_bottom_panel .search-text').on('keyup', function (){   
      var get_input_search_value = $(this).val();
      if(get_input_search_value.length >=2){
          fetch("/apps/konnect/search/users?query="+get_input_search_value)
              .then(res => res.json()
                  .then(json => { 
                    console.log(json);
                    $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();
                    for (var i = 0; i < json.length; i++) {
                        console.log( json[i].mail );
                        if ( typeof(json[i].mail) !== "undefined" && json[i].mail !== null ){                                             
                            $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").append('<div class="search_item_block" data-search-item-id="'+json[i].id+'"><div class="search_item_info_block"><div class="search_item_info_title"><strong>'+json[i].displayName+'</strong><span>, '+json[i].jobTitle+'</span></div><div class="search_item_info_email">'+json[i].mail+'</div></div><div class="search_item_btn_block"><button type="button" class="button search_item_btn" data-search-item-id="'+json[i].id+'">Select</button></div></div>');
                        }
                    }
                    if(json.length <=0){
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","flex");
                    }else{
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                    }                    
                  }));            
      }
    
  }); 

  $('.customize_search_bottom_panel .search-button').on('click', function (){   
      var get_input_search_value = $(this).closest(".customize_search_bottom_panel").find(".search-text").val();
      if(get_input_search_value.length >=2){
          fetch("/apps/konnect/search/users?query="+get_input_search_value)
              .then(res => res.json()
                  .then(json => { 
                    console.log(json);
                    $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();
                    for (var i = 0; i < json.length; i++) {
                        console.log( json[i].mail );
                        if ( typeof(json[i].mail) !== "undefined" && json[i].mail !== null ){                                             
                            $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").append('<div class="search_item_block" data-search-item-id="'+json[i].id+'"><div class="search_item_info_block"><div class="search_item_info_title"><strong>'+json[i].displayName+'</strong><span>, '+json[i].jobTitle+'</span></div><div class="search_item_info_email">'+json[i].mail+'</div></div><div class="search_item_btn_block"><button type="button" class="button search_item_btn" data-search-item-id="'+json[i].id+'">Select</button></div></div>');
                        }
                    }
                    if(json.length <=0){
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","flex");
                    }else{
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                    }
                    
                  }));            
      }
    
  }); 

  //$('#qrUrl').on('keyup', generateQrCode);
  
  $('.customize_your_business_cards_information_section .customize_front_form_inputes .customize_search_bottom_panel .search-clear').on('click', function (){   

        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #first-name").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #last-name").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #job-title").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #email").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #main_mobile").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #fax").val("");

        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #street").val("");
          
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #city").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #state").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #zip-code").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #business").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #loan-officer-nmls").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #qrUrl").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #custom-url").prop("checked", false);
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes  #qrUrl").attr("data-officer-url","");
    
        $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();
        $(this).closest(".customize_search_bottom_panel").find(".search-text").val("");
        $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                        
  }); 

  $(document).on("click",".customize_front_section .customize_search_bottom_panel .search-form-results-html .search_item_block",function() {
    
        var get_profile_id = $(this).attr("data-search-item-id");
  //  alert("info "+get_profile_id);
          fetch("/apps/konnect/users/"+get_profile_id)
              .then(res => res.json()
                  .then(profile_json => { 
                    console.log(profile_json);
                   // alert(profile_json.mobilePhone);
                    $(this).closest(".product_page_customize_business_card_section").find("#first-name").val(profile_json.givenName);
                    $(this).closest(".product_page_customize_business_card_section").find("#last-name").val(profile_json.surname);
                    $(this).closest(".product_page_customize_business_card_section").find("#job-title").val(profile_json.jobTitle);
                    $(this).closest(".product_page_customize_business_card_section").find("#email").val(profile_json.mail);
                    
                    $(this).closest(".product_page_customize_business_card_section").find("#main_mobile").val(profile_json.mobilePhone);
                    $(this).closest(".product_page_customize_business_card_section").find("#main_mobile").attr("data-main-mobile",profile_json.mobilePhone);
                    
                    $(this).closest(".product_page_customize_business_card_section").find("#fax").val(profile_json.faxNumber);
                    $(this).closest(".product_page_customize_business_card_section").find("#fax").attr("data-fax",profile_json.faxNumber);
                    
                    if(profile_json.streetAddress == null){
                        $(this).closest(".product_page_customize_business_card_section").find("#street").val(profile_json.officeLocation);  
                        $(this).closest(".product_page_customize_business_card_section").find("#street").attr("data-street",profile_json.officeLocation);  
                    }else{
                        $(this).closest(".product_page_customize_business_card_section").find("#street").val(profile_json.streetAddress);
                        $(this).closest(".product_page_customize_business_card_section").find("#street").attr("data-street",profile_json.streetAddress);  
                    }
                    
                    $(this).closest(".product_page_customize_business_card_section").find("#city").val(profile_json.city);
                    $(this).closest(".product_page_customize_business_card_section").find("#state").val(profile_json.state);
                    $(this).closest(".product_page_customize_business_card_section").find("#zip-code").val(profile_json.postalCode);

                    $(this).closest(".product_page_customize_business_card_section").find("#city").attr("data-city",profile_json.city);
                    $(this).closest(".product_page_customize_business_card_section").find("#state").attr("data-state",profile_json.state);
                    $(this).closest(".product_page_customize_business_card_section").find("#zip-code").attr("data-zip-code",profile_json.postalCode);
                    
                    $(this).closest(".product_page_customize_business_card_section").find("#business").val(profile_json.businessPhones);
                    $(this).closest(".product_page_customize_business_card_section").find("#business").attr("data-business",profile_json.businessPhones);
                    
                    $(this).closest(".product_page_customize_business_card_section").find("#loan-officer-nmls").val(profile_json.nlmsNumber);
                    $(this).closest(".product_page_customize_business_card_section").find("#qrUrl").val(profile_json.officerUrl);
                    $(this).closest(".product_page_customize_business_card_section").find("#qrUrl").attr("data-officer-url",profile_json.officerUrl);
                    $(this).closest(".product_page_customize_business_card_section").find("#custom-url").prop("checked", false);

                    let licensedStates = "";
                    if (profile_json.licensedStates) {
                      licensedStates = profile_json.licensedStates.join(", ");
                      if (profile_json.licensedStates.length > 1) {
                        const last = licensedStates.lastIndexOf(", ");
                        licensedStates = `${licensedStates.slice(0, last)} and ${licensedStates.slice(last + 2)}`;
                      }
                    }
                    $(this).closest(".product_page_customize_business_card_section").find("#licensed-in-ex-nc-and-va").val(licensedStates);
                    
                    $(this).closest(".customize_search_bottom_panel").find(".search-text").val("");
                    $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                    $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();

                    generateQrCode();
                    
                  }));            
                        
  });


  $(document).on("click",".customize_team_member_details .search-form-results-html .search_item_block",function() {
    
        var get_profile_id = $(this).attr("data-search-item-id");
  //  alert("info "+get_profile_id);
          fetch("/apps/konnect/users/"+get_profile_id)
              .then(res => res.json()
                  .then(profile_json => { 
                    console.log(profile_json);                
                      
                    $(this).closest(".customize_team_member_details").find('[id$="first-name"]').val(profile_json.givenName);                      
                    $(this).closest(".customize_team_member_details").find('[id$="last-name"]').val(profile_json.surname);
                    $(this).closest(".customize_team_member_details").find('[id$="job-title"]').val(profile_json.jobTitle);
                    //$(this).closest(".customize_team_member_details").find('[id$="email"]').val(profile_json.mail);                    
                    
                    $(this).closest(".customize_team_member_details").find(".search-text").val("");
                    $(this).closest(".customize_team_member_details").find(".import_incorrect_data").css("display","none");
                    $(this).closest(".customize_team_member_details").find(".search-form-results-html").empty();
                  }));            
                        
  });  

  $(document).on("click",".customize_team_member_details .search-clear",function() {  
          $(this).closest(".customize_team_member_details").find('[id$="first-name"]').val("");                      
          $(this).closest(".customize_team_member_details").find('[id$="last-name"]').val("");
          $(this).closest(".customize_team_member_details").find('[id$="job-title"]').val("");
          //$(this).closest(".customize_team_member_details").find('[id$="email"]').val("");                    
          
          $(this).closest(".customize_team_member_details").find(".search-text").val("");
          $(this).closest(".customize_team_member_details").find(".import_incorrect_data").css("display","none");
          $(this).closest(".customize_team_member_details").find(".search-form-results-html").empty();                      
  }); 
    

  if($('#file').get(0).files.length === 0){
      console.log("No files selected.");
  }

  $('[type="text"]').on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) { 
      e.preventDefault();
    //  alert("etner");
      return false;
    }
  }); 

  
  $("input[name='properties[Custom URL]']").on('click', function (){  
      if($(this).is(':checked')){
        //alert("checked");        
        $("#qrUrl").removeClass("input_lock_field");
      }else{
        var get_default_officer_url = $(".product_page_customize_business_card_section").find("#qrUrl").attr("data-officer-url");
        $(".product_page_customize_business_card_section").find("#qrUrl").val(get_default_officer_url);
        //alert("not checked");
        $("#qrUrl").addClass("input_lock_field");
      }    
  }); 

  $("#properties_pronouns").on('change', function (){  
      $("#pronouns").val($(this).val());
      if ($('#properties_pronouns').val().length == 0) {
            $("#pronouns").val("No");
      }
          
  });   
  
  $("#line-item_switch-rounded-co_brand").on('click', function (){  
      if($(this).is(':checked')){
        //alert("checked");  
          $(".line-item-property__field_Co_brand").slideDown();

          $("#co_brand_file").prop('disabled', false);        
          $("#co_brand_first-name").prop('disabled', false);        
          $("#co_brand_last-name").prop('disabled', false);        
          $("#co_brand_nmls-id").prop('disabled', false);        
          $("#co_brand_phone_number").prop('disabled', false);        
          $("#co_brand_email").prop('disabled', false);        
          $("#co_brand_qrUrl").prop('disabled', false);        
          $("#co_brand_notes").prop('disabled', false);        


          var co_brand_get_front_card_type = $("input[name='properties[Choose Yard Sign Design]']:checked").val();                  
          
          if(co_brand_get_front_card_type == "Provide My Own"){
              $(".co_brand_line-item-property__field_provide_my_own_file").show();
              $(".co_brand_line-item-property__field_provide_my_own_file #co_brand_line-item-provide_my_own_file").prop("disabled", false);                      
          }else{
              $(".co_brand_line-item-property__field_provide_my_own_file").hide();
              $(".co_brand_line-item-property__field_provide_my_own_file #co_brand_line-item-provide_my_own_file").prop("disabled", true);                    
          }           
        
      }else{
        //alert("not checked");        
          $(".line-item-property__field_Co_brand").slideUp();
          $("#co_brand_file").prop('disabled', true);   
          $("#co_brand_first-name").prop('disabled', true);        
          $("#co_brand_last-name").prop('disabled', true);        
          $("#co_brand_nmls-id").prop('disabled', true);        
          $("#co_brand_phone_number").prop('disabled', true);        
          $("#co_brand_email").prop('disabled', true);        
          $("#co_brand_qrUrl").prop('disabled', true);  
         $("#co_brand_notes").prop('disabled', true);   
          
          $(".co_brand_line-item-property__field_provide_my_own_file").hide();
          $(".co_brand_line-item-property__field_provide_my_own_file #co_brand_line-item-provide_my_own_file").prop("disabled", true);                    
                    
      }    
  }); 
    
  
});

 
